export const STYLE = {
  radius: 46,
  color: '#17181a',
};
